module.exports = __webpack_public_path__ + "img/public/AdminIcons/siteConfigureIcon.svg?2b13fdbe";